<div class="w2-nothing-inplay text-center">
	<div class="col-xs-12 w2-nothing-inplay-icon h1 text-danger">
		<i class="fa fa-tags"></i>
	</div>
	<div class="col-xs-12 w2-nothing-inplay-text">
		{{{noInPlayItemMessage}}}
	</div>
</div>